import { Component, OnInit } from '@angular/core';
import { ServicioFirebaseService } from 'src/app/servicios/servicio-firebase.service';
import { Observable } from 'rxjs';
import { DatosModule } from 'src/app/modelos/datos/datos.model';
@Component({
  selector: 'app-seccion-historial',
  templateUrl: './seccion-historial.component.html',
  styleUrls: ['./seccion-historial.component.css']
})
export class SeccionHistorialComponent implements OnInit {
 // datos:Observable<any>;
  public tipoActividades:string;
  public datos: Observable<DatosModule[]>;
  secuencia:DatosModule[];
  renderizado:boolean = false;
  public totalActividades:number;
  public calificacionAlta:number;
  public promediogeneral:number=0;
  public pieChartLabels = ["deficiente","regular","sobresaliente"];
  public pieChartData = [];
  public pieChartType = 'pie';
  public pieChart
  constructor(private servicio:ServicioFirebaseService) { }

  ngOnInit() {
   this.cargarInformacion();
  }
  borrarRegistroActividiad(act){
    this.servicio.eliminarActividadRealizada(act);
  }
  cargarInformacion(){
    var calificaciones = [];
    var labels = [];
    this.servicio.afAuth.authState.subscribe(res=>{
      this.datos=this.servicio.darDatosActividadesRealizadas(res.uid);
      this.datos.subscribe((res)=>{
        this.cargarInformaciondespe(res);
        this.totalActividades=res.length;
      });
    });
  }
  cargarInformaciondespe(res: DatosModule[]) {
    var sobresaliente = 0;
    var regular = 0;
    var deficiente = 0;
    var masalta=0;
    var calificaciones=[];
    var promedio=0;
    res.forEach((element) => {
      console.log(element);
      var calificacion = parseInt(element.calificacion);
      calificaciones.push(calificacion);
      if(calificacion>=masalta){
        masalta=calificacion;
      }
      if (calificacion < 69) {
        deficiente++;
      }
      if (calificacion >= 70 && calificacion < 90) {
        regular++;
      }
      if (calificacion >= 90) {
        sobresaliente++;
      }
    });
    promedio=Math.round(((calificaciones.reduce(function(a, b) { return a + b; }, 0))/res.length));
    this.promediogeneral=promedio;
    this.calificacionAlta=masalta;
    this.pieChartData = [deficiente, regular, sobresaliente];
    this.renderizado = true;
  }
}
